import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";
import { useSeo } from "@/hooks/useSeo";
import { ASSETS } from "@/lib/site";

export default function NotFound() {
  useSeo({ title: "Página não encontrada | Miríade Turismo", description: "A página que você procura não foi encontrada." });
  return (
    <section data-testid="notfound-page" className="relative flex min-h-[70vh] items-center justify-center overflow-hidden px-4 py-20">
      <div className="absolute -right-16 top-10 h-72 w-72 rounded-full bg-brand-light blur-3xl" />
      <div className="absolute -left-16 bottom-10 h-72 w-72 rounded-full bg-blush blur-3xl" />
      <div className="relative mx-auto max-w-lg text-center">
        <img src={ASSETS.mascot} alt="Mascote da Miríade Turismo" className="mx-auto h-44 w-44 object-contain drop-shadow-xl animate-float" />
        <p className="mt-6 font-heading text-6xl font-bold text-brand">404</p>
        <h1 className="mt-3 font-heading text-2xl font-bold tracking-tight text-ink sm:text-3xl">
          Ops, essa rota não estava no nosso roteiro.
        </h1>
        <p className="mt-3 text-base leading-relaxed text-ink-soft">
          A página que você procura pode ter mudado de lugar. Vamos te levar de volta para o caminho certo.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link to="/" data-testid="notfound-home-btn" className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand px-7 py-3.5 text-sm font-semibold text-white transition-all hover:scale-[1.02] hover:bg-brand-hover sm:w-auto">
            <Home size={18} /> Voltar para o início
          </Link>
          <Link to="/buscar-viagens" data-testid="notfound-search-btn" className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-brand/30 bg-white px-7 py-3.5 text-sm font-semibold text-brand transition-all hover:bg-brand-light sm:w-auto">
            <Search size={18} /> Buscar uma viagem
          </Link>
        </div>
      </div>
    </section>
  );
}
